import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "80vh", textAlign: "center", p: 4 }}>
      <Typography variant="h1" sx={{ fontSize: 80, fontWeight: 900, color: "#244C77", lineHeight: 1 }}>404</Typography>
      <Typography variant="h5" sx={{ mt: 2, mb: 1, fontWeight: 700 }}>Page Not Found</Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 400 }}>
        The page you are looking for does not exist or has been moved.
      </Typography>
      <Button variant="contained" onClick={() => navigate("/")}
        sx={{ background: "linear-gradient(135deg,#4A7BA8,#244C77)", px: 4, borderRadius: 2 }}>
        Go Home
      </Button>
    </Box>
  );
}
